module.exports = __webpack_public_path__ + "img/checked.d12047aa.svg";